module.exports = __webpack_public_path__ + "img/1.204a98c8.svg";